export { HumanizedPredicate } from './src/humanized-predicate';
export { PredicateIconClassNames } from './src/predicate-icon-classnames';

